import { useParams, Navigate, Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { PageLayout } from "@/components/PageLayout";
import { solutions } from "@/data/solutions";

export default function SolutionDetail() {
  const { slug } = useParams();
  const s = solutions.find((x) => x.slug === slug);
  if (!s) return <Navigate to="/solutions" replace />;

  return (
    <PageLayout
      seoTitle={s.seoTitle}
      seoDescription={s.seoDescription}
      path={`/solutions/${s.slug}`}
      back={{ to: "/solutions", label: "All solutions" }}
      eyebrow="Solution"
      title={s.title}
      subtitle={s.intro}
      testid={`solution-${s.slug}`}
    >
      <section className="mb-14" aria-labelledby="what-we-do">
        <h2 id="what-we-do" className="font-display text-2xl tracking-tight text-paper mb-6">What we do</h2>
        <div className="grid gap-px bg-white/10 border border-white/10 sm:grid-cols-2 rounded-2xl overflow-hidden">
          {s.whatWeDo.map((w, i) => (
            <div key={i} className="bg-surface p-6">
              <p className="text-sm text-paper/90 leading-relaxed">{w}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-14" aria-labelledby="what-you-get">
        <h2 id="what-you-get" className="font-display text-2xl tracking-tight text-paper mb-6">What you get</h2>
        <ul className="space-y-3">
          {s.deliverables.map((d, i) => (
            <li key={i} className="flex items-start gap-3 text-sm text-fog">
              <Icons.Check size={16} className="text-paper mt-0.5 shrink-0" aria-hidden="true" />
              {d}
            </li>
          ))}
        </ul>
      </section>

      <section className="rounded-2xl border border-white/10 bg-surface p-8" aria-labelledby="who-for">
        <h2 id="who-for" className="font-display text-xl tracking-tight text-paper mb-3">Who it's for</h2>
        <p className="text-sm text-fog leading-relaxed max-w-2xl">{s.whoFor}</p>
        <Link
          to="/contact"
          data-testid="solution-cta"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-paper text-black text-sm font-medium px-5 py-3 hover:bg-white transition-colors"
        >
          Talk to us
          <Icons.ArrowUpRight size={15} aria-hidden="true" />
        </Link>
      </section>
    </PageLayout>
  );
}
